<template>
  <header class="header">
    <base-container :fluid="true">
      <div class="header__inner-wrapper">
        <div class="header__item--left">
          <slot name="leftAligned"></slot>
        </div>
        <div class="header__item--right">
          <slot name="rightAligned"></slot>
        </div>
      </div>
    </base-container>
  </header>
</template>

<script>
export default {}
</script>

<style scoped rel="stylsheet/scss" lang="scss">
.header {
  padding: 38px 0 24px;
  &__inner-wrapper {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
  }
  $left-aligned-width: 658px;
  $right-aligned-width: 376px;

  &__item--left,
  &__item--right {
    display: inline-flex;
    flex-flow: column nowrap;
  }

  &__item--left {
    width: $left-aligned-width;
  }
  &__item--right {
    min-width: $right-aligned-width;
    margin-top: 30px;
  }

  // wrap
  @media screen and (min-width: 1100px) {
    &__item--left {
      width: 60%;
      max-width: $left-aligned-width;
    }
    &__item--right {
      width: 35%;
      max-width: $right-aligned-width;
      margin-top: 0;
    }
  }
}
</style>
